import Survey from "../Survey";
import { useState, useEffect } from "react";
import appApi from "../../../api";
import SurveyResults from "../SurveyResults";

const PreviewSurvey = ({ themeColors }) => {
    //todo: maybe theme colors should be fetched here instead of passed in
    const [companyDetails, setCompanyDetails] = useState({});
    const [finished, setFinished] = useState(false);

    const dummyResults = {
        self_assessed_financial_score: 500,
        financial_score: 500,
        responses: [],
        recommendations: ["example recommendation 1", "example recommendation 2"],
    };

    const dummyQuestionResponses = {
        questions: [],
        responses: {},
        appointment: null,
    };

    //todo: this should be hardcoded, why fetch?
    useEffect(() => {
        (async () => {
            const response = await appApi.get("/surveys/preview");
            if (response.data.success) {
                setCompanyDetails(response.data.data);
            } else {
                //todo: better error handling
                console.error(response.data.message);
            }
        })();
    }, []);

    return !finished ? (
        <Survey
            themeColors={themeColors}
            companyDetails={companyDetails}
            onFinish={() => {
                setFinished(true);
            }}
        />
    ) : (
        <SurveyResults
            themeColors={themeColors}
            questionResponses={dummyQuestionResponses}
            surveyResults={dummyResults}
            appointmentLink={null}
            resetAssessment={() => setFinished(false)}
            bookAppointment={() => {}}
            emailResults={() => true}
        />
    );
};

export default PreviewSurvey;
